import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';

const SummaryValue = ({ value }) => {
    if (!value) {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    return <Typography variant='body2'>{value}</Typography>;
};

SummaryValue.propTypes = {
    value: PropTypes.string,
};

export const DeviceConfigSummary = ({ summary }) => {
    const translate = useTranslate();
    const items = [
        { key: 'model', label: translate('common.model'), value: summary?.model },
        { key: 'contractor', label: translate('common.contractor'), value: summary?.contractor },
        { key: 'operator', label: translate('common.operator'), value: summary?.operator },
        { key: 'collectionPoint', label: translate('common.collectionPoint'), value: summary?.collectionPoint },
    ];

    return (
        <Stack className='device-config-summary' direction={{ xs: 'column', md: 'row' }} spacing={3}>
            {items.map(item => (
                <Box key={item.key} className='device-config-summary-item'>
                    <Typography variant='body2' className='device-config-summary-label'>
                        {item.label}
                    </Typography>
                    <SummaryValue value={item.value} />
                </Box>
            ))}
        </Stack>
    );
};

DeviceConfigSummary.propTypes = {
    summary: PropTypes.shape({
        model: PropTypes.string,
        contractor: PropTypes.string,
        operator: PropTypes.string,
        collectionPoint: PropTypes.string,
    }),
};
